import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from '@proximus/ng-common';
import { InternetProduct, Location } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-internet-product-selector-modal',
  templateUrl: './internet-product-selector-modal.component.html',
})
export class InternetProductSelectorModalComponent {
  productsAvailableForDeepLink: Array<InternetProduct> = [];
  selectedInternetProduct: InternetProduct;
  selectedInternetProductBuffer: InternetProduct;
  installationAddresses: { [key: string]: Location };
  confirm: Function;

  constructor(
    private router: Router,
    private translationService: TranslationService,
  ) {}

  onCancel() {
    this.router.navigate(['/overview']);
  }

  onConfirm() {
    this.selectedInternetProduct = this.selectedInternetProductBuffer;
    this.confirm(this.selectedInternetProduct);
  }

  public updateSelectedRadio(selectedProduct) {
    this.selectedInternetProductBuffer = selectedProduct;
  }
}
